import moment from 'moment';

const spanIncludesFutureDays = (startDate, scheduleFormat) => {
  let lastDay = moment(startDate).add(scheduleFormat - 1, 'days').startOf('day');
  return moment(lastDay).isAfter(moment().startOf('day'));
}

export default spanIncludesFutureDays;



// WEBPACK FOOTER //
// ./src/Components/Schedule/SevenNineDay/utils/live-schedule-view-security-filter/utils/spanIncludesFutureDays.js